import { useEffect } from 'react'

export default function useCheckUndefined<
  X extends { [k: string]: any | undefined }
>(mapToCheck: X) {
  const keys = Object.keys(mapToCheck)

  useEffect(() => {
    const t = setTimeout(() => {
      if (process.env.AUTOMATION)
        for (let key of keys)
          if (!mapToCheck[key]) alert(`${key} is not defined`)
    }, 500)

    return () => {
      clearTimeout(t)
    }
  }, Object.values(mapToCheck))

  return [keys.some((k) => !mapToCheck[k]), mapToCheck as Required<X>] as const
}
